module.exports = __webpack_public_path__ + "img/t1.d7757f00.jpg";